"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelInputTypeToJSON = exports.ModelInputTypeFromJSONTyped = exports.ModelInputTypeFromJSON = exports.ModelInputType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var ModelInputType;
(function (ModelInputType) {
    ModelInputType["JSON"] = "JSON";
    ModelInputType["JSONTEMPLATE"] = "JSON_TEMPLATE";
})(ModelInputType = exports.ModelInputType || (exports.ModelInputType = {}));
function ModelInputTypeFromJSON(json) {
    return ModelInputTypeFromJSONTyped(json, false);
}
exports.ModelInputTypeFromJSON = ModelInputTypeFromJSON;
function ModelInputTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ModelInputTypeFromJSONTyped = ModelInputTypeFromJSONTyped;
function ModelInputTypeToJSON(value) {
    return value;
}
exports.ModelInputTypeToJSON = ModelInputTypeToJSON;
